// extracted by mini-css-extract-plugin
export default {"list":"language_list__Zzv6r","inactive":"language_inactive__2XBNN","active":"language_active__odnjD"};